import { useEffect } from "react";
import { useNavigate } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { useLinkedProjects } from "@/hooks/Network/useLinkedProjects";
import { routes } from "@/routes";

export function PortfolioRedirect(): React.ReactNode {
  const { data: projects, error } = useLinkedProjects();
  const navigate = useNavigate();

  useEffect(() => {
    if (!projects) {
      return;
    }

    // If you're admin in at least one project
    if (projects.some((x) => x.userRole !== "resident")) {
      void navigate(routes.portfolio.overview(), { replace: true });
    } else {
      void navigate(routes.home.home({ slug: projects[0].slug }), { replace: true });
    }
  }, [navigate, projects]);

  if (error) {
    return <ErrorPage error={error} />;
  }

  return null;
}
